/**
 * The default class for important html elements that the page js interacts with
 * abstract class do not instantiate!
 */
export default class HtmlElement {

    constructor($element) {
        this.$element = $element;
    }

    /**
     * Check if the element exists on the current page
     * @returns {boolean}
     */
    exists() {
        if(this.$element.length > 0) {
            return true;
        }
        return false;
    }

    /**
     * Get total $element height
     * @param {boolean} margin whether to include the element margin in the returned height
     * @returns {int}
     */
    getHeight(margin = false) {
        return this.$element.outerHeight(margin);
    }
}